<template>
  <div class="header-sp">
      <div class="header-sp-text">
        <p class="animation-text company-sp noWrap">{{ work.company }}</p>
        <break-text
          class="title-sp animation-text"
          :content="work.name"
        />
        <break-text
          class="description-sp animation-text"
          :content="work.description"
        />
      </div>
      <div class="header-sp-image">
        <img  style="width:100% ; object-fit: contain;" alt='' :src="getImageUrl(work.screenShot1)" />
      </div>
    </div>
</template>

<script>
import BreakText from '@/components/common/BreakText.vue';

export default {
  components: { BreakText },
  props: {
    work: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getImageUrl(imgName) {
      if (imgName) {
        // eslint-disable-next-line global-require,import/no-dynamic-require
        return require(`@/assets/${imgName}`);
      }
      return '';
    },
  },
};
</script >

<style lang="scss" scoped>
  .header-sp{
    box-sizing: border-box;
    background: #F1F3F4;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 42px 24px 70px;
    .header-sp-text{
      box-sizing: border-box;
      margin-bottom: 40px;
      max-width: 454px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
    .header-sp-image{
      display: flex;
      height: 232px;
    }
  }
  .company-sp, .description-sp {
    white-space: pre-line;
    color: #222222;
    letter-spacing: 0.43px;
    font-weight: 400;
  }
  .company-sp {
    margin-bottom: 6px;
    font-size: 14px;
    line-height: 20px;
  }
  .title-sp {
    margin-bottom: 16px;
    font-size: 26px;
    line-height: 40px;
    font-weight: bold;
    color: #222222;
    letter-spacing: 0.85px;
  }
  .description-sp {
    font-size: 13.5px;
    line-height: 24px;
  }
  .noWrap {
    white-space: nowrap;
  }
</style>
